import { TypesMedecinsPres } from '@/enum/AAT.enum';

export class MedecinPres {
	typeMedecinPres: TypesMedecinsPres;
	autreCas: string;

	constructor(
		typeMedecinPres: TypesMedecinsPres = TypesMedecinsPres.TRAITANT_OU_MEDECIN,
		autreCas: string = ''
	) {
		this.typeMedecinPres = typeMedecinPres;
		this.autreCas = autreCas;
	}
}

export interface MedecinPresState {
	medecinPres?: MedecinPres;
}
